import Vue from 'vue'
import Router from 'vue-router'

// Containers
const DefaultContainer = () => import('@/containers/DefaultContainer')

// Views
const Dashboard = () => import('@/views/Dashboard')

//Customers
const ActiveCustomers = () => import('@/views/customers/ActiveCustomers')
const InactiveCustomers = () => import('@/views/customers/InactiveCustomers')
const Customer = () => import('@/views/customers/Customer')
const RedFlag = () => import('@/views/customers/RedFlags')

//Loans
const PendingLoans = () => import('@/views/loans/PendingLoans')
const DeclinedLoans = () => import('@/views/loans/DeclineLoans')
const ApprovedLoans = () => import('@/views/loans/ApprovedLoans')
const DisbursementList = () => import('@/views/loans/DisbursementList')
const ActiveLoans = () => import('@/views/loans/ActiveLoans')
const LoanDetails = () => import('@/views/loans/LoanDetails')
const AllLoans = () => import('@/views/loans/AllLoans')

// Views - Pages
const Page404 = () => import('@/views/pages/Page404')
const Page500 = () => import('@/views/pages/Page500')
const Login = () => import('@/views/pages/Login')

// Users
const Users = () => import('@/views/users/Users')
const Roles = () => import('@/views/users/Roles')
const User = () => import('@/views/users/User')
const Role = () => import('@/views/users/Role')

//Configurations
const SystemSettings = () => import('@/views/configurations/SystemSettings')
const ActivityLogs = () => import('@/views/activity-logs/ActivityLogs');

Vue.use(Router)

const router = new Router({
  mode: 'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      redirect: '/dashboard',
      name: 'Home',
      component: DefaultContainer,
      meta: { 
        requiresAuth: true
      },
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard
        },
        {
          path: 'customers',
          redirect: '/customers/active-customers',
          name: 'Customers',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'active-customers',
              name: 'Active Customers',
              component: ActiveCustomers,
            },
            {
              path: 'inactive-customers',
              name: 'Inactive Customers',
              component: InactiveCustomers,
            },
            {
              path: ':id',
              meta: { label: 'Customer Details'},
              name: 'Customer',
              component: Customer,
            },
            {
              path: 'red-flags/:user_id',
              meta: { label: 'Customer Redflag Details'},
              name: 'RedFlag',
              component: RedFlag
            },
          ]
        },
        {
          path: 'loans',
          redirect: '/loans/pending-loans',
          name: 'Loans',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'pending-loans',
              name: 'Pending Loans',
              component: PendingLoans
            },
            {
              path: 'all-loans',
              name: 'All Loans',
              component: AllLoans
            },
            {
              path: 'declined-loans',
              name: 'Declined Loans',
              component: DeclinedLoans
            },
            {
              path: 'approved-loans',
              name: 'Approved Loans',
              component: ApprovedLoans
            },
            {
              path: 'active-loans',
              name: 'Active Loans',
              component: ActiveLoans
            },
            {
              path: 'disbursement-list',
              name: 'Disbursement List',
              component: DisbursementList
            },
            {
              path: ':id',
              meta: { label: 'Loan Details'},
              name: 'Loan Details',
              component: LoanDetails,
            }
          ]
        },
        {
          path: 'transactions',
          redirect: '/transactions/activity-logs',
          name: 'Transactions',
          component: {
            render (c) { return c('router-view') }
          },
          meta: { 
            requiresAuth: true
          },
          children: [
            {
              path: 'activity-logs',
              name: 'Activity Logs',
              component: ActivityLogs
            }
          ]
        },
        {
          path: 'Configurations',
          redirect: '/configurations/users',
          name: 'Configurations',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'users',
              name: 'Users',
              component: Users
            },
            {
              path: 'system-settings',
              name: 'System Settings',
              component: SystemSettings
            },
            {
              path: 'roles-permissions',
              name: 'Roles and Permission',
              component: Roles
            },
            {
              path: 'users/:id',
              meta: { label: 'User Details'},
              name: 'User',
              component: User,
            },
            {
              path: 'roles-permissions/:id',
              meta: { label: 'Role Details'},
              name: 'Role',
              component: Role,
            },
          ]
        }
      ]
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: { 
        guest: true
      }
    },
  ]
})

export default router;